import React from 'react'
import PropTypes from 'prop-types'

const GoalBannerProgressBar = ({levelData}) => {
    return (
        <div className="flex items-center mt-2 mb-2 pb-4">
            <div className="rounded-full h-2.5 flex-1 bg-accent/40">
                <div
                    className="h-2.5 rounded-full bg-secondary-foreground"
                    style={{width: `${levelData.percentComplete}%`}}
                ></div>
            </div>
            <span className="ml-2 text-sm text-gray-700 dark:text-white">
                {levelData.completeModulesQty}/{levelData.allModulesQty}
            </span>
        </div>
    )
}

GoalBannerProgressBar.propTypes = {
    levelData: PropTypes.object
}

export default GoalBannerProgressBar
